<div disabled="true" style="--columns: {{columns}}" class="type-select-container">
    <a class="type-select"
       [class.disabled]="disabled || type.disabled ? true : null"
       data-qa-label="TypeSelect"
       *ngFor="let type of types"
       [ngClass]="{'selected': type.data === selected}"
       (click)="onSelect(type.data)">
        {{ type.label }}
        <i *ngIf="type.hasValue" class="tce-icon-circle-check has-value-icon"></i>
    </a>
</div>
